import { version } from './../../package.json'

export const environment = {
  production: false,
  apiUrl: 'https://ap-api-staging.dcoenvs.com/',
  version: version,
}
